import { render, staticRenderFns } from "./PreviewPopup.vue?vue&type=template&id=34b87b36&scoped=true&"
import script from "./PreviewPopup.vue?vue&type=script&lang=js&"
export * from "./PreviewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b87b36",
  null
  
)

export default component.exports